// extracted by mini-css-extract-plugin
export default {"contents":"healthalertpanel_contents__Z1u1V","item":"healthalertpanel_item__HfqT0","title":"healthalertpanel_title__7bYzL","value":"healthalertpanel_value__hO7E3"};